import {
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import InfoModal from 'src/components/InfoModal';
import InfoPopupContent from 'src/__mocks__/InfoPopupContent';

function ConversionEfficiencyCard(props) {
  const { value } = props;
  let displayValue = '';
  if (!Number.isNaN(value)) {
    displayValue = `${Number(value).toFixed(1)} %`;
  }

  const cardStyle = {
    display: "block",
    height: "100%"
  };

  return (
    <Card style={cardStyle}>
      <CardContent> 
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h6"
        >
          CONVERSION EFFICIENCY:
          <InfoModal content={InfoPopupContent.CONVERSION} />
        </Typography>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h4"
        >
          <b>{ displayValue }</b>
          <LinearProgress
            value={value}
            variant="determinate"
          />
        </Typography>
      </CardContent>
    </Card>
  );
}

ConversionEfficiencyCard.propTypes = {
  value: PropTypes.number
};
export default ConversionEfficiencyCard;
